import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { HEADER_ATTACHED_ROUTE_DATA } from './constants/layout.constant';
import { ConnectionStateComponent } from './components/connection-state/connection-state.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';
import { ToastHostComponent } from './components/toast-host/toast-host.component';
import { WalletMiniComponent } from './modules/wallet/components/wallet-mini/wallet-mini.component';
import { LayoutService } from './services/layout.service';
import { EVENT_DRIVEN_STARTUP } from './providers/event-driven-startup.providers';

@Component({
	imports: [
		RouterOutlet,
		HeaderComponent,
		FooterComponent,
		SplashScreenComponent,
		ToastHostComponent,
		ConnectionStateComponent,
		SideMenuComponent,
		WalletMiniComponent
	],
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss'
})
export class AppComponent {
	/** Desktop swaps the footer for the side menu and mini-wallet. */
	readonly isDesktop = inject(LayoutService).isDesktop;

	private readonly router = inject(Router);

	/** Whether the page on screen opts its top section into the app bar — see {@link HEADER_ATTACHED_ROUTE_DATA}. */
	readonly headerAttached = toSignal(
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd),
			map(() => this.deepest(this.router.routerState.snapshot.root).data[HEADER_ATTACHED_ROUTE_DATA] === true)
		),
		{ initialValue: false }
	);

	constructor() {
		inject(EVENT_DRIVEN_STARTUP);
	}

	private deepest(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
		return route.firstChild ? this.deepest(route.firstChild) : route;
	}
}
